import { render, staticRenderFns } from "./PatientAdmin.vue?vue&type=template&id=0f2667d7"
import script from "./PatientAdmin.vue?vue&type=script&lang=js"
export * from "./PatientAdmin.vue?vue&type=script&lang=js"
import style0 from "./PatientAdmin.vue?vue&type=style&index=0&id=0f2667d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports